/**
 * KiekkoKingi section controller: category-grid
 * Kept external so the browser can defer and cache this code.
 */
(() => {
  const kkScript = document.currentScript;
  if (!kkScript) return;

  (() => {
      const rootId = kkScript.dataset.rootId;
      const sectionId = kkScript.dataset.sectionId;
      const destroy = (root) => {
        if (!root || !root.kkCategoryGridCleanup) return;
        root.kkCategoryGridCleanup.forEach((cleanup) => cleanup());
        root.kkCategoryGridCleanup = null;
        root.removeAttribute('data-kk-category-initialized');
      };
  
      const init = (root) => {
        if (!root || root.dataset.kkCategoryInitialized === 'true') return;
        root.dataset.kkCategoryInitialized = 'true';
        root.kkCategoryGridCleanup = [];
  
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const track = root.querySelector('[data-category-track]');
        const cards = track ? Array.from(track.querySelectorAll('[data-category-card]')) : [];
        const dots = Array.from(root.querySelectorAll('[data-category-dot]'));
        const current = root.querySelector('[data-category-current]');
        const progress = root.querySelector('[data-category-progress]');
        let activeIndex = 0;
        let frame = 0;
  
        root.classList.add('kk-cat-js-ready');
  
        const setActive = (nextIndex) => {
          if (!cards.length) return;
          activeIndex = Math.max(0, Math.min(nextIndex, cards.length - 1));
          dots.forEach((dot, index) => {
            const isActive = index === activeIndex;
            dot.classList.toggle('is-active', isActive);
            if (isActive) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
          if (current) current.textContent = String(activeIndex + 1);
          if (progress) progress.style.transform = `scaleX(${(activeIndex + 1) / cards.length})`;
        };
  
        const findClosestCard = () => {
          if (!track || !cards.length) return;
          const trackRect = track.getBoundingClientRect();
          const target = trackRect.left + Math.min(trackRect.width * 0.22, 76);
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;
          cards.forEach((card, index) => {
            const distance = Math.abs(card.getBoundingClientRect().left - target);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          setActive(closestIndex);
        };
  
        const onScroll = () => {
          if (frame) return;
          frame = window.requestAnimationFrame(() => {
            frame = 0;
            findClosestCard();
          });
        };
  
        if (track && cards.length > 1) {
          track.addEventListener('scroll', onScroll, { passive: true });
          window.addEventListener('resize', onScroll, { passive: true });
          root.kkCategoryGridCleanup.push(() => track.removeEventListener('scroll', onScroll));
          root.kkCategoryGridCleanup.push(() => window.removeEventListener('resize', onScroll));
  
          dots.forEach((dot) => {
            const onClick = () => {
              const index = Number(dot.dataset.categoryDot || 0);
              const targetCard = cards[index];
              if (!targetCard) return;
              targetCard.scrollIntoView({
                behavior: reducedMotion ? 'auto' : 'smooth',
                block: 'nearest',
                inline: 'start'
              });
            };
            dot.addEventListener('click', onClick);
            root.kkCategoryGridCleanup.push(() => dot.removeEventListener('click', onClick));
          });
  
          setActive(0);
        }
  
        if (root.dataset.entryAnimation === 'true' && !reducedMotion && 'IntersectionObserver' in window) {
          const entryObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              root.classList.add('is-visible');
              entryObserver.disconnect();
            });
          }, { threshold: 0.12 });
          entryObserver.observe(root);
          root.kkCategoryGridCleanup.push(() => entryObserver.disconnect());
        } else {
          root.classList.add('is-visible');
        }
  
        const onBlockSelect = (event) => {
          const selectedBlock = event.target.closest('[data-category-card]');
          if (!selectedBlock || !root.contains(selectedBlock)) return;
          selectedBlock.scrollIntoView({
            behavior: reducedMotion ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        };
        document.addEventListener('shopify:block:select', onBlockSelect);
        root.kkCategoryGridCleanup.push(() => document.removeEventListener('shopify:block:select', onBlockSelect));
      };
  
      const initialRoot = document.getElementById(rootId);
      init(initialRoot);
  
      const onSectionLoad = (event) => {
        if (!event.detail || event.detail.sectionId !== sectionId) return;
        init(event.target.querySelector('[data-kk-category-grid]'));
      };
  
      const onSectionUnload = (event) => {
        if (!event.detail || event.detail.sectionId !== sectionId) return;
        destroy(event.target.querySelector('[data-kk-category-grid]'));
        document.removeEventListener('shopify:section:load', onSectionLoad);
        document.removeEventListener('shopify:section:unload', onSectionUnload);
      };
  
      document.addEventListener('shopify:section:load', onSectionLoad);
      document.addEventListener('shopify:section:unload', onSectionUnload);
    })();
})();